import { createSlice, createSelector } from '@reduxjs/toolkit'

const initialState = {
  data: {
    shops: [],
    brands: [],
  },
  loaded: false,
  loading: false,
  error: null,
}

const shops = createSlice({
  name: 'shops',
  initialState: initialState,
  reducers: {
    requestShops(state) {
      state.loading = true
      state.error = null
    },
    successShops(state, { payload }) {
      const { data } = payload || {}
      if (data) {
        state.data = data
      }
      state.loading = false
      state.loaded = true
      state.error = null
    },
    failureShops(state, { payload }) {
      const { data } = payload
      state.loading = false
      state.error = data
    },
  },
})

export const fetchShops = ({ refresh = false, errToString = true } = {}) => async (dispatch, getState, { api }) => {
  try {
    const shops = getState().shops
    if (shops.loaded && !refresh) {
      dispatch(successShops())
      return
    } else {
      dispatch(requestShops())
      const response = await api.shops()
      const { result = 'success', ...data } = response
      if (result === 'success') {
        dispatch(successShops({ data }))
      } else {
        dispatch(failureShops({ data: response }))
      }
    }
  } catch (err) {
    dispatch(failureShops({ data: errToString ? err.toString() : err }))
  }
}

export const getShopsData = createSelector(
  state => state.shops,
  shops => ({ ...shops }),
)

export const { requestShops, successShops, failureShops } = shops.actions

export default shops.reducer
